import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The sticky header bar for a component hosted in the dynamic sidebar drawer.
 *
 * The drawer floats its close and collapse buttons over the top-left of its own
 * content (`left: -20px`, so they cover its first 20px). This component owns the
 * one treatment that keeps a header clear of them, so hosts never hand-roll
 * their own and drift.
 *
 * Standalone so standalone hosts can import it without pulling in the whole of
 * `NgSharedModule`, which still re-exports it for module-declared hosts.
 */
@Component({
  selector: 'pt-dynamic-sidebar-header',
  templateUrl: './dynamic-sidebar-header.component.html',
  styleUrls: ['./dynamic-sidebar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicSidebarHeaderComponent {}
